exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader {\n  text-align: center;\n  height: 100vh;\n  position: fixed;\n  width: 100%;\n  margin-top: 50%; }\n  .loader > img {\n    width: 200px;\n    height: 200px; }\n", ""]);

// exports
